/*=========================================================================================
  File Name: moduleEcommerceState.js
  Description: Ecommerce Module State
  ----------------------------------------------------------------------------------------
  Item Name: BCC Pubs
  Author: SweetAs
  Author URL: http://sweetas.xyz
==========================================================================================*/

/* eslint-disable */
export default {
    ipid:'',
    cartItems: [ ],
    wishList: [ ]
}
/* eslint-enable */
